var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcRoundArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99336 4.92097C1.91575 4.99838 1.85418 5.09034 1.81217 5.19158C1.77016 5.29283 1.74853 5.40136 1.74853 5.51097C1.74853 5.62059 1.77016 5.72912 1.81217 5.83036C1.85418 5.93161 1.91575 6.02356 1.99336 6.10097L7.53336 11.641C7.59503 11.7028 7.66829 11.7518 7.74894 11.7853C7.82959 11.8187 7.91605 11.8359 8.00336 11.8359C8.09067 11.8359 8.17713 11.8187 8.25777 11.7853C8.33842 11.7518 8.41168 11.7028 8.47336 11.641L14.0134 6.10097C14.34 5.77431 14.34 5.24764 14.0134 4.92097C13.6867 4.59431 13.16 4.59431 12.8334 4.92097L8.00002 9.74764L3.16669 4.91431C2.84669 4.59431 2.31336 4.59431 1.99336 4.92097Z",
    fill: "url(#paint0_linear_5837_1534)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5837_1534",
    x1: -1.46122,
    y1: 12.3548,
    x2: 11.8375,
    y2: 0.0193284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8517"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundArrowDown);
export default __webpack_public_path__ + "static/media/ic_round-arrow-down.5acb46c38186f3069e908a7cec1382c5.svg";
export { ForwardRef as ReactComponent };